import { UserActionTrackEventBase } from '../../types';
import { TrackedEvent } from '../../trackedEvent';

export class TrackLogout extends UserActionTrackEventBase {
    constructor() {
        super(TrackedEvent.UserLoggedOut);
    }
}
